import { render, staticRenderFns } from "./studentInterview.vue?vue&type=template&id=90b142d6&"
import script from "./studentInterview.vue?vue&type=script&lang=js&"
export * from "./studentInterview.vue?vue&type=script&lang=js&"
import style1 from "./studentInterview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports